import React from 'react'
import { Notifications } from '@mui/icons-material';

export const AutoNotification = (props) => {

  const handleClick = () => {
    if (props.onClick) {
      props.onClick()
    }
  }

  return (
    <button className="auto-notification" onClick={handleClick}>
      <div>
        <h2><Notifications className="btn-point-events"/> {props.title}</h2>
        { props.priority === '1' &&
        <span className="important-tag"> Important </span>
        }
      </div>
    </button>
  )
}